import _, { isBoolean, isNumber, isString } from 'lodash'

import { Primitive } from 'types/primitive'
import { parseValidJSON } from 'utils/json'
import { isNumericString, withoutOuterQuotes } from 'utils/string'

export const parsePrimitiveValue = (value: unknown, type: Primitive): number | string => {
  let parsedValue: number | string

  if (_.isNil(value)) {
    parsedValue = ''
  } else if (type === 'string') {
    parsedValue = withoutOuterQuotes(JSON.stringify(value))
  } else {
    parsedValue = value as number
  }

  return parsedValue
}

export const parseSchemaParametersToDTO = (
  params: Record<string, boolean | null | number | string | undefined>,
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(params).map(
      ([key, value]: [string, boolean | null | number | string | undefined]): [string, unknown] => [
        key,
        parseSchemaParameter(value),
      ],
    ),
  )

const parseSchemaParameter = (value: boolean | null | number | string | undefined): unknown => {
  if (value === null || value === undefined) {
    return null
  } else if (isBoolean(value) || isNumber(value)) {
    return value
  } else if (isString(value)) {
    if (value.length === 0) {
      return null
    } else if (isNumericString(value)) {
      // Backend due to its "soft required validation" needs strings
      return parseFloat(value).toString()
    } else {
      return parseValidJSON(value)
    }
  }

  throw Error('Unsupported value type')
}
